
import React, { useCallback, useState } from "react";
import ReactDOM from 'react-dom/client';
import { PieChart, Pie, Sector, Cell } from "recharts";
export interface mydata { data: any };

const renderActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={payload.color}
                aria-hidden="true"
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={payload.color}
                aria-hidden="true"
            />
            <path
                d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
                stroke={payload.color}
                fill="none"
            />
            <circle cx={ex} cy={ey} r={2} fill={payload.color} stroke="none" />
            <foreignObject
                x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey - 10} width="110" height="200" className={cos >= 0 ? 'text-container' : 'text-container etichettaDX'}
            >
                <div>
                    {payload.name}<br/>
                    <span className="bold">{`${value}%`}</span>
                </div>
            </foreignObject>
        </g>
    );
};
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const App = ({
    data
}: mydata): JSX.Element => {
    const [activeIndex, setActiveIndex] = useState(0);
    const onPieEnter = useCallback(
        (_: any, index: any) => {
            setActiveIndex(index);
        },
        [setActiveIndex]
    );

    console.log(data)

    return (
        <PieChart width={400} height={400} aria-hidden="true">
            <Pie aria-hidden="true"
                activeIndex={activeIndex}
                activeShape={renderActiveShape}
                data={data}
                cx={200}
                cy={200}
                innerRadius={60}
                outerRadius={80}
                fill="#ccc"
                dataKey="value"
                onMouseEnter={onPieEnter}
            >
                {data.map((entry: any, index: any) => (
                    <Cell key={`cell-${index}`} fill={data[index].color} />
                ))}
            </Pie>
        </PieChart>
    );
}

var index = 0;
document.querySelectorAll('[data-id="root"]').forEach(function (elem) {
    var json = elem.getAttribute('data-json');
    if (json != null) {
        var data = JSON.parse(json.toString());
        const root = ReactDOM.createRoot(
            elem as HTMLElement
        );
        root.render(
            <React.StrictMode>
                <App data={data} />
            </React.StrictMode>
        );
    }
    index++;
}
)

